<script setup>
import Header from './Header.vue';
import Footer from './Footer.vue';
import { ref } from 'vue';

const sections = ref([
  {
    label: 'Vision',
    key: 'vision',
  },
  {
    label: 'Mission',
    key: 'mission',
  },
  {
    label: 'Values',
    key: 'values',
  },
  {
    label: 'Story',
    key: 'story',
  },
]);
</script>

<template>
  <div class="min-h-screen bg-white">
    <Header />

    <!-- Main About Section -->
    <section class="bg-white pb-32" style="padding-top: 50vh">
      <div class="container mx-auto px-6 md:px-4">
        <div class="max-w-[800px] mx-auto">
          <!-- Page Title -->
          <div class="text-left mb-24">
            <h1
              class="text-3xl md:text-6xl font-light text-black mb-6 md:mb-8 tracking-tight leading-tight"
            >
              {{ $t('about.title') }}
            </h1>
            <p class="text-lg md:text-xl text-black/50 font-light leading-relaxed">
              {{ $t('about.subtitle') }}
            </p>
          </div>

          <!-- Vision, Mission, Values Sections -->
          <div class="space-y-20">
            <div
              v-for="section in sections"
              :key="section.key"
              class="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 md:gap-12"
            >
              <!-- Left: Title -->
              <div class="md:pt-1">
                <h2 class="text-2xl md:text-3xl font-light text-black">
                  {{ $t(`about.${section.key}.title`) }}
                </h2>
              </div>

              <!-- Right: Content -->
              <div class="space-y-4">
                <p
                  v-for="(paragraph, index) in $t(`about.${section.key}.content`)"
                  :key="index"
                  class="text-base md:text-lg text-black/60 font-light leading-relaxed"
                >
                  {{ paragraph }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Section -->
    <Footer />
  </div>
</template>
